import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { BladeSubtitle, FormTitle, SectionWrapper } from './styles';

interface Props {
  label: string;
}

const SelectedTradeIn = ({ label }: Props) => {
  // Get phobio trade-in details if they exist
  const phobioDetails = window && window.sessionStorage.getItem('phobioDetails');
  const tradeInData = phobioDetails !== null ? JSON.parse(phobioDetails) : undefined;
  if (!tradeInData) {
    return null;
  }

  return (
    <>
      <SectionWrapper>
        <BladeSubtitle>{ReactHtmlParser(label)}</BladeSubtitle>
        <FormTitle>{tradeInData.userPhone.phone}</FormTitle>
        <FormTitle>{tradeInData.userPhone.imei}</FormTitle>
      </SectionWrapper>
      <hr />
    </>
  );
};

export default SelectedTradeIn;
